import { Component, Input, OnInit } from '@angular/core';
import { RequirementResponse } from '../../../../../api';

@Component({
  selector: 'base-inquiry-requirements-modal',
  templateUrl: './base-inquiry-requirements-modal.component.html',
})
export class BaseInquiryRequirementsModalComponent implements OnInit {
  @Input() inquiryRequirements: RequirementResponse[];
  @Input() candidateRequirements: RequirementResponse[];

  checkedRequirements: (RequirementResponse & { isMatched: boolean })[];

  ngOnInit(): void {
    this.checkedRequirements = this.inquiryRequirements.map((requirement) => {
      return { ...requirement, isMatched: this.candidateRequirements.some((item) => item.id === requirement.id) };
    });
  }
}
